import { render, staticRenderFns } from "./Couponsupplierlist.vue?vue&type=template&id=df3e4626&scoped=true&"
import script from "./Couponsupplierlist.vue?vue&type=script&lang=js&"
export * from "./Couponsupplierlist.vue?vue&type=script&lang=js&"
import style0 from "./Couponsupplierlist.vue?vue&type=style&index=0&id=df3e4626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3e4626",
  null
  
)

export default component.exports